import { Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldWrapper, FormlyModule } from '@ngx-formly/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NzFormModule } from 'ng-zorro-antd/form';

/**
 * @fileoverview added by tsickle
 * Generated from: form-field.wrapper.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from 'ng-zorro-antd/grid';
import * as ɵngcc2 from 'ng-zorro-antd/form';
import * as ɵngcc3 from '@angular/common';
import * as ɵngcc4 from '@ngx-formly/core';

function FormlyWrapperFormField_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "nz-form-label", 4);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("nzRequired", ctx_r0.to.required && ctx_r0.to.hideRequiredMarker !== true)("nzFor", ctx_r0.id);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.to.label, " ");
} }
function FormlyWrapperFormField_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "formly-validation-message", 5);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("field", ctx_r3.field);
} }
class FormlyWrapperFormField extends FieldWrapper {
    /**
     * @return {?}
     */
    get errorState() {
        return this.showError ? 'error' : '';
    }
}
FormlyWrapperFormField.ɵfac = function FormlyWrapperFormField_Factory(t) { return ɵFormlyWrapperFormField_BaseFactory(t || FormlyWrapperFormField); };
FormlyWrapperFormField.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FormlyWrapperFormField, selectors: [["formly-wrapper-nz-form-field"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 7, vars: 3, consts: [[4, "ngIf"], [3, "nzValidateStatus", "nzErrorTip"], ["fieldComponent", ""], ["errorTpl", ""], [3, "nzRequired", "nzFor"], [3, "field"]], template: function FormlyWrapperFormField_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "nz-form-item");
        ɵngcc0.ɵɵtemplate(1, FormlyWrapperFormField_ng_container_1_Template, 3, 3, "ng-container", 0);
        ɵngcc0.ɵɵelementStart(2, "nz-form-control", 1);
        ɵngcc0.ɵɵelementContainer(3, null, 2);
        ɵngcc0.ɵɵtemplate(5, FormlyWrapperFormField_ng_template_5_Template, 1, 1, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r2 = ɵngcc0.ɵɵreference(6);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.to.label && ctx.to.hideLabel !== true);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("nzValidateStatus", ctx.errorState)("nzErrorTip", _r2);
    } }, directives: [ɵngcc1.NzRowDirective, ɵngcc2.NzFormItemComponent, ɵngcc3.NgIf, ɵngcc1.NzColDirective, ɵngcc2.NzFormControlComponent, ɵngcc2.NzFormLabelComponent, ɵngcc4.ɵc], encapsulation: 2 });
const ɵFormlyWrapperFormField_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(FormlyWrapperFormField);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FormlyWrapperFormField, [{
        type: Component,
        args: [{
                selector: 'formly-wrapper-nz-form-field',
                template: `
    <nz-form-item>
      <ng-container *ngIf="to.label && to.hideLabel !== true">
        <nz-form-label [nzRequired]="to.required && to.hideRequiredMarker !== true" [nzFor]="id">
          {{ to.label }}
        </nz-form-label>
      </ng-container>
      <nz-form-control [nzValidateStatus]="errorState" [nzErrorTip]="errorTpl">
        <ng-container #fieldComponent></ng-container>
        <ng-template #errorTpl let-control>
          <formly-validation-message [field]="field"></formly-validation-message>
        </ng-template>
      </nz-form-control>
    </nz-form-item>
  `
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: form-field.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FormlyNzFormFieldModule {
}
FormlyNzFormFieldModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: FormlyNzFormFieldModule });
FormlyNzFormFieldModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function FormlyNzFormFieldModule_Factory(t) { return new (t || FormlyNzFormFieldModule)(); }, imports: [[
            CommonModule,
            ReactiveFormsModule,
            NzFormModule,
            FormlyModule.forChild({
                wrappers: [
                    {
                        name: 'form-field',
                        component: FormlyWrapperFormField
                    },
                ]
            }),
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(FormlyNzFormFieldModule, { declarations: function () { return [FormlyWrapperFormField]; }, imports: function () { return [CommonModule,
        ReactiveFormsModule,
        NzFormModule, ɵngcc4.FormlyModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FormlyNzFormFieldModule, [{
        type: NgModule,
        args: [{
                declarations: [FormlyWrapperFormField],
                imports: [
                    CommonModule,
                    ReactiveFormsModule,
                    NzFormModule,
                    FormlyModule.forChild({
                        wrappers: [
                            {
                                name: 'form-field',
                                component: FormlyWrapperFormField
                            },
                        ]
                    }),
                ]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: ngx-formly-ng-zorro-antd-form-field.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { FormlyNzFormFieldModule, FormlyWrapperFormField as ɵa };

//# sourceMappingURL=ngx-formly-ng-zorro-antd-form-field.js.map